import React from 'react';
import update from 'immutability-helper';
import { connect } from 'react-redux';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import forEach from 'lodash/forEach';
import {
    loadManifests,
    getManifests,
    getIsFetching,
    clearManifests,
    clearErrorMessage,
    storeSearch,
    getManifestsSearchForm,
    INITIAL_MANIFEST_SEARCH_FORM,
} from '../../../manifests/duck';
import { postUnrelatedManifestsAnalysis } from '../../analysisDuck';
import { validateFields } from '../../../../shared/utils/handleBlowoutValidations';
import ManifestSearch from '../../../manifests/manifestsList/components/ManifestSearch';
import ManifestsTable from '../../../manifests/manifestsList/components/ManifestsTable';
import moment from 'moment/moment';

class UnrelatedManifestsModal extends React.PureComponent {
    state = {
        search: this.props.manifestsSearchForm,
        selectedManifests: [],
        validations: {},
        showEpsDownload: false,
    };

    componentWillReceiveProps(nextProps) {
        if (this.props.manifestsSearchForm !== nextProps.manifestsSearchForm) {
            this.setState({
                search: Object.assign({}, nextProps.manifestsSearchForm),
            });
        }
    }

    componentWillUnmount() {
        this.props.clearErrorMessage();
        this.props.storeSearch(INITIAL_MANIFEST_SEARCH_FORM);
        this.props.clearManifests();
    }

    handleChange = e => {
        const name = e.target.name;
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        this.setState({
            search: update(this.state.search, {
                [name]: { $set: value },
            }),
        });
    };

    handleDateChange = name => date => {
        this.setState({
            search: update(this.state.search, {
                [name]: { $set: date },
            }),
        });
    };

    handleCheckSelect = (row, isSelected) => {
        let temp = this.state.selectedManifests;
        if (isSelected) {
            temp.push(row.manifestId);
            if (this.state.validations.manifests) {
                let tempVal = this.state.validations;
                delete tempVal.manifests;
                this.setState({ validations: tempVal });
            }
        } else {
            const index = temp.indexOf(row.manifestId);
            if (index > -1) {
                temp.splice(index, 1);
            }
        }
        this.setState({ selectedManifests: temp });
    };

    handleCheckSelectAll = (isSelected, rows) => {
        let temp = [];
        if (isSelected) {
            //if all are selected
            forEach(rows, row => {
                temp.push(row.manifestId);
            });
        }
        if (this.state.validations.manifests) {
            let tempVal = this.state.validations;
            delete tempVal.manifests;
            this.setState({ validations: tempVal });
        }
        this.setState({ selectedManifests: temp });
    };

    handleConfirmSelection = () => {
        const { selectedManifests } = this.state;
        const validations = validateFields({ selectedManifests });
        this.setState({ validations });
        if (!validations.manifests) {
            const body = {
                manifestIds: selectedManifests,
            };
            this.props.postUnrelatedManifestsAnalysis(this.props.abnormalityId, body);
            this.props.onClose();
        }
    };

    handleSubmit = e => {
        e.preventDefault();
        const preparedForm = this.prepareFormDataForPost(this.state.search);
        this.props.loadManifests(preparedForm);
    };

    handleReset = () => {
        this.setState({
            search: Object.assign({}, INITIAL_MANIFEST_SEARCH_FORM),
        });
    };

    prepareFormDataForPost = form => {
        return update(form, {
            runDate: {
                $set: form.runDate ? moment(form.runDate).format('YYYY-MM-DD') : '',
            },
            pLaneExit: {
                $set: form.pLaneExit ? moment(form.pLaneExit).toISOString() : '',
            },
            connectingRunTime: {
                $set: form.connectingRunTime ? moment(form.connectingRunTime).toISOString() : '',
            },
        });
    };

    render() {
        const { showModal, onClose, onHide, manifests, isFetching } = this.props;
        const { search, selectedManifests, validations, showEpsDownload } = this.state;

        return (
            <Modal show={showModal} bsSize="large" backdrop="static" onHide={onHide}>
                <Modal.Header>
                    <Modal.Title>Search unrelated manifests</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <Row>
                            <Col xs={12}>
                                <ManifestSearch
                                    unrelated
                                    search={search}
                                    isFetching={isFetching}
                                    handleChange={this.handleChange}
                                    handleDateChange={this.handleDateChange}
                                    handleSubmit={this.handleSubmit}
                                    handleReset={this.handleReset}
                                    showEpsDownload={showEpsDownload}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <ManifestsTable
                                    isFetching={isFetching}
                                    isSelectable
                                    manifests={manifests}
                                    onCheckSelect={this.handleCheckSelect}
                                    onCheckSelectAll={this.handleCheckSelectAll}
                                    selectedManifests={selectedManifests}
                                    validations={validations}
                                />
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="pull-right"
                        style={{ marginRight: 20 }}
                        bsStyle="success"
                        onClick={this.handleConfirmSelection}
                    >
                        Confirm Selection
                    </Button>
                    <Button
                        className="pull-right"
                        style={{ marginRight: 20 }}
                        bsStyle="default"
                        onClick={onClose}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default connect(
    state => ({
        manifests: getManifests(state),
        isFetching: getIsFetching(state),
        manifestsSearchForm: getManifestsSearchForm(state),
    }),
    {
        loadManifests,
        postUnrelatedManifestsAnalysis,
        clearManifests,
        clearErrorMessage,
        storeSearch,
    }
)(UnrelatedManifestsModal);
